import { contextFactory } from '@frontend/design-system';
import { AIChatbotResponse, MessageFeedback, WeaveCopilotSource } from '../types';

export interface ChatbotAssistantContextProps {
  messages: AIChatbotResponse[];
  isLoading: boolean;
  isSending: boolean;
  isOpen: boolean;
  position: { x: number; y: number } | null;
  locationId: string;
  isPopoutOpen: boolean;
  source: WeaveCopilotSource;
  isFirstTimeInteracted: boolean;
  addMessage: (message: AIChatbotResponse) => void;
  updateFeedback: (messageId: string, feedback: MessageFeedback) => void;
  sendMessage: (message: string) => void;
  setIsLoading: (loading: boolean) => void;
  toggleChatbotOpen: () => void;
  setPosition: (position: { x: number; y: number }) => void;
  openPopoutWindow: () => void;
  setIsPopoutOpen: (isOpen: boolean) => void;
}

export const [ChatbotAssistantContext, useChatbotAssistant] = contextFactory<ChatbotAssistantContextProps>();
